/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CostTypeDto } from '../../models/cost-type-dto';

export interface GetCostType$Params {
  id: string;
}

export function getCostType(http: HttpClient, rootUrl: string, params: GetCostType$Params, context?: HttpContext): Observable<StrictHttpResponse<CostTypeDto>> {
  const rb = new RequestBuilder(rootUrl, getCostType.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CostTypeDto>;
    })
  );
}

getCostType.PATH = '/v0/costTypes/{id}';
